import { create } from "zustand";

const useJobStore = create((set) => ({
  jobs: [],
  hasHydrated: true, // No longer using persist, always ready

  setJobs: (jobObject) => {
    const jobArray = Array.isArray(jobObject)
      ? jobObject
      : jobObject
      ? Object.values(jobObject)
      : [];

    set({
      jobs: jobArray,
    });
  },

  removeJob: (jobId) => set((state) => ({
    jobs: state.jobs.filter(j => j._id !== jobId),
  })),

  addJob: (job) => set((state) => ({
    jobs: [job, ...state.jobs],
  })),

  clearJobs: () => set({ jobs: [] }),
}));

export default useJobStore;
